export const REFER_FRIEND_TRACKING = {
  ZONE: 'refer_a_friend',
  PAGE: 'refer_friend',
} as const
